import React, { useEffect, useState, Fragment, useRef } from "react";
import { Pagination, PageHeader, paginate } from "../../../Common";
import services from "../services";
import authService from "../../Common/services";
import { LoadingSpinerComponent } from "../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import { LoadingMaterialTable } from "../../../Common/table";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import Joi from "@hapi/joi";
import { QRCodePrintWithFactorySchemaObject } from "../QRCodePrintWithFactorySchema";
import { validateProperty, validate, CheckBox } from "../../Common";
import { Checkbox } from "@material-ui/core";
import MessageModal from "../../../UI/Modal/MessageModal";
import tokenService from "../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createpdf';
import { makeStyles } from '@material-ui/core/styles';
var QRCode = require("qrcode.react");

const screenCode = "QRCODEPRINTWITHFACTORY";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

export function QRCodePrintWithFactory(props) {

  const componentRef = useRef();
  const classes = useStyles();

  const [groups, setGroups] = useState([]);
  const [operationEntity, setOperationEntity] = useState([]);
  const [routes, setRoutes] = useState([]);
  const [errors, setErrors] = useState({});
  const [qrTagsDetails, setQRTagsDetails] = useState([]);
  const [saveData, setSaveData] = useState([]);
  const [qrTag, setQRTag] = useState({
    groupID: "0",
    operationEntityID: "0",
    routeID: "0",
    isActive: false
  });
  const [messageModel, setMessageModel] = useState({
    hidden: true,
    type: "Success",
    disciption: "Completed Success",
  });
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isOperationEntityFilterEnabled: false,
  });

  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const schema = Joi.object(QRCodePrintWithFactorySchemaObject).options({ allowUnknown: true });

  const [checkAll, setCheckAll] = useState(false);

  const selectAll = () => {
    setCheckAll(!checkAll);
  };

  useEffect(() => {
    getPermissions();
  }, []);

  useEffect(() => {
    if (qrTag.groupID != 0 || qrTag.groupID != "") {
      trackPromise(getOperationEntityByGroup());
    }
  }, [qrTag.groupID]);

  useEffect(() => {
    trackPromise(
      getAllRoutesForDropDown()
    )
  }, [qrTag.operationEntityID]);

  useEffect(() => {
    if(qrTag.routeID != '0'){
      handleSearch();
    }
  }, [qrTag.routeID]);

  function handleGroupChange(target) {
    validateInputs(target);

    setQRTag({
      ...qrTag,
      groupID: target.value,
      operationEntityID: "0",
    });
  }

  function handleOperationEntityChange(target) {
    validateInputs(target);

    setQRTag({
      ...qrTag,
      operationEntityID: target.value,
    });
  }

  function handleChange(e) {
    const target = e.target;

    if (target.name === "collectionCategoryCode") {
      if (target.value.length === 4) return false
    }

    const value = target.name === 'isActive' ? target.checked : target.value;

    const error = { ...errors }
    const errorMessage = validateProperty(target, QRCodePrintWithFactorySchemaObject)
    errorMessage ? error[target.name] = errorMessage : delete error[target.name]


    setQRTag({
      ...qrTag,
      [e.target.name]: value
    })
    setErrors(error)
  }


  function validateInputs(target) {
    const error = { ...errors };
    const errorMessage = validateProperty(target, QRCodePrintWithFactorySchemaObject);
    errorMessage
      ? (error[target.name] = errorMessage)
      : delete error[target.name];

    setErrors(error);
  }

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);

    var isAuthorized = permissions.find(
      (p) => p.permissionCode == "VIEWQRCODEPRINTWITHFACTORY"
    );

    if (isAuthorized === undefined) {
      props.history.push("/unauthorized");
    }

    var isGroupFilterEnabled = permissions.find(
      (p) => p.permissionCode == "GROUPDROPDOWN"
    );
    var isOperationEntityFilterEnabled = permissions.find(
      (p) => p.permissionCode == "OPERATIONENTITYDROPDOWN"
    );

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isOperationEntityFilterEnabled:
        isOperationEntityFilterEnabled !== undefined,
    });

    var token = tokenService.getUserDetailsFromToken();

    setQRTag({
      ...qrTag,
      groupID: token.groupID,
      operationEntityID: token.operationEntityID,
    });

    trackPromise(getGroupsForDropdown());
  }

  async function getGroupsForDropdown() {
    const result = await services.getAllGroupsForDropdown();
    setGroups(result);
  }

  async function getOperationEntityByGroup() {
    const data = await services.getOperationEntityByGroup(qrTag.groupID);
    setOperationEntity(data);
  }

  async function getAllRoutesForDropDown() {
    const routeList = await services.getAllRoutesByFactoryID(qrTag.operationEntityID);
    setRoutes(routeList);
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  async function handleSearch() {

    const errorMessages = validate(schema, qrTag);
    errorMessages !== null ? setErrors(errorMessages) : setErrors({});

    if (errorMessages) return;

    const response = await services.getQRTagByGroupIDOperationEntityID(
      qrTag.groupID,
      qrTag.operationEntityID,
      qrTag.routeID
    );
    setQRTagsDetails(response);
  }

  function handleClick(data) {
    let collectionTagData = {
      collectionTagID: data.collectionTagID,
      tagNo: data.tagNo

    };

    let dataRecords = [...saveData];

    var isEnable = dataRecords.find(
      (p) => p.collectionTagID == data.collectionTagID
    );
    if (isEnable === undefined) {
      dataRecords.push(collectionTagData);
    } else {
      var index = dataRecords.indexOf(isEnable);
      dataRecords.splice(index, 1);
    }
    setSaveData(dataRecords);
  }

  async function handleSave(e) {
    e.preventDefault();
    const response = await services.updateStatus(saveData);
    setMessageModel({
      ...messageModel,
      hidden: false,
      type: response.statusCode,
      disciption: response.message,
    });

    afterSuccessfulyChanged(response.statusCode);
    setTimeout(() => {
      modalDismissHandler();
    }, 1500);
  }

  async function afterSuccessfulyChanged() {
    setQRTagsDetails([]);
    const response = await services.getQRTagByGroupIDOperationEntityID(
      qrTag.groupID,
      qrTag.operationEntityID,
      qrTag.routeID
    );
    setQRTagsDetails(response);
  }


  async function handleTrigger(e) {
    console.clear();

    const response = await services.updateStatus(saveData);
    setMessageModel({
      ...messageModel,
      hidden: false,
      type: response.statusCode,
      disciption: response.message,
    });
    afterSuccessfulyChanged(response.statusCode);
    setSaveData([]);
    setTimeout(() => {
      modalDismissHandler();
    }, 1500);
  }

  function modalDismissHandler() {
    setMessageModel({ ...messageModel, hidden: true });
  }

  function handleClickAll(e){
    var tagDataCopy = [...saveData];

    if(e.target.checked){
      qrTagsDetails.forEach(x => {
        let collectionTagData = {
          collectionTagID: x.collectionTagID,
          tagNo: x.tagNo
        };

        var isEnable = tagDataCopy.find((p) => p.collectionTagID == x.collectionTagID);
        if(isEnable === undefined){
          tagDataCopy.push(collectionTagData);
        }
      });
      setSaveData(tagDataCopy);
    }
    else{
      setSaveData([]);
    }
    setTimeout(() => {
      modalDismissHandler();
    }, 1500);
    
  }

  return (
    <Fragment>
      <LoadingSpinerComponent />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <PageHeader title="QR Code Print" />
            <div className="card-body">
              <form>
                <div className="form-group row">
                  <div className="col-md pb-1">
                    <InputLabel shrink id="groupID">
                      Group *
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="groupID"
                      id="groupID"
                      name="groupID"
                      value={qrTag.groupID}
                      disabled={!permissionList.isGroupFilterEnabled}
                      onChange={(e) => handleGroupChange(e.target)}
                    >
                      <MenuItem value="0">--Select Group--</MenuItem>
                      {generateDropDownMenu(groups)}
                    </Select>
                    {errors["groupID"] && (
                      <FormHelperText error>{errors["groupID"]}</FormHelperText>
                    )}
                  </div>

                  <div className="col-md pb-1">
                    <InputLabel shrink id="operationEntityID">
                      Operation Entity *
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="operationEntityID"
                      id="operationEntityID"
                      name="operationEntityID"
                      value={qrTag.operationEntityID}
                      disabled={!permissionList.isOperationEntityFilterEnabled}
                      onChange={(e) => handleOperationEntityChange(e.target)}
                    >
                      <MenuItem value="0">--Select Operation Entity--</MenuItem>
                      {generateDropDownMenu(operationEntity)}
                    </Select>
                    {errors["operationEntityID"] && (
                      <FormHelperText error>
                        {errors["operationEntityID"]}
                      </FormHelperText>
                    )}
                  </div>
                  <div className="col-md pb-1">
                    <InputLabel shrink id="routeID">Route *</InputLabel>
                    <Select
                      fullWidth
                      id="routeID"
                      name="routeID"
                      value={qrTag.routeID}
                      onChange={(e) => handleChange(e)}>
                      <MenuItem value="0">--Select Route--</MenuItem>
                      {generateDropDownMenu(routes)}
                    </Select>
                    {errors["routeID"] && (
                      <FormHelperText error>
                        {errors["routeID"]}
                      </FormHelperText>
                    )}
                  </div>
                </div>
                   
                <div className="form-group row">
                    <div className="col-md ">
                    <InputLabel shrink id="routeID">QR Tag Display *</InputLabel>
                      <input
                        id="isActive"
                        switch="none"
                        className="mr-2"
                        type="checkbox"
                        name="isActive"
                        onChange={(e) => handleChange(e)}
                        checked={qrTag.isActive}
                      />
                      <label htmlFor="isActive" data-on-label="Yes"
                        data-off-label="No"></label>
                    </div>
                  </div>
              </form>
              <LoadingMaterialTable
                title=""
                columns={[
                  {
                    title: (
                      <label>
                        <Checkbox
                          color="primary"
                          onClick={(e) => handleClickAll(e)}
                          onChange={selectAll}
                          checked={qrTagsDetails.length != 0 && saveData.length == qrTagsDetails.length}
                        ></Checkbox>
                        Select All
                      </label>
                    ),
                    sorting: false,
                    field: "select",
                    type: "boolean",
                    render: (data) => (
                      <Checkbox
                        color="primary"
                        onClick={() => handleClick(data)}
                        checked={!(saveData.find((x) => x.collectionTagID == data.collectionTagID) == undefined)}
                      ></Checkbox>
                    ),
                  },
                  { title: "Tag Number", field: "tagNo" },
                  {
                    title: "QR Code",
                    field: "qrCode",
                    render: (rawData) => (
                      <QRCode value={rawData.tagNo} size={56} />
                    ),
                  },
                ]}
                data={qrTagsDetails}
              />

              <div className="card-footer">
                <input
                  type="submit"
                  className="btn btn-primary pull-right ml-2"
                  value="Print"
                  onClick={(e) => trackPromise(handleSave(e))}
                />
                <ReactToPrint
                  trigger={() => (
                    <input
                    documentTitle={"QR Tags"}
                      type="submit"
                      className="btn btn-primary pull-right ml-2"
                      value="Create PDF"
                    />
                  )}
                  onAfterPrint={(e) => handleTrigger(e)}
                  content={() => componentRef.current}
                />
              </div>
            </div>
            <div hidden={true}>
              <CreatePdf data={saveData} ref={componentRef} isPrint={qrTag} />
            </div>
          </div>
        </div>
      </div>

      <MessageModal
        hidden={messageModel.hidden}
        messageType={messageModel.type}
        messageDescription={messageModel.disciption}
      />
    </Fragment>
  );
}
